import apiFetch from '../apiFetch'

export default function (body, token) {
  return apiFetch({endPoint: `ResetPassword`, method: 'POST', body, token})
}
